/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LootshopTransactionHistoryItem
 */
export interface LootshopTransactionHistoryItem {
    /**
     * LootShop order ID
     * @type {string}
     * @memberof LootshopTransactionHistoryItem
     */
    id?: string;
    /**
     * Total amount paid in USD cents
     * @type {number}
     * @memberof LootshopTransactionHistoryItem
     */
    amount?: number;
    /**
     * Formatted USD amount (e.g., "$12.50")
     * @type {string}
     * @memberof LootshopTransactionHistoryItem
     */
    amountFormatted?: string;
    /**
     * Human-readable description
     * @type {string}
     * @memberof LootshopTransactionHistoryItem
     */
    description?: string;
    /**
     * Number of items in order
     * @type {number}
     * @memberof LootshopTransactionHistoryItem
     */
    itemCount?: number;
    /**
     * Payment method used
     * @type {string}
     * @memberof LootshopTransactionHistoryItem
     */
    paymentMethod?: string;
    /**
     * Order timestamp
     * @type {Date}
     * @memberof LootshopTransactionHistoryItem
     */
    createdAt?: Date;
    /**
     * True when the order has no LootBox items (a gift-card purchase); Order Again shows only these
     * @type {boolean}
     * @memberof LootshopTransactionHistoryItem
     */
    isGiftCard?: boolean;
}

/**
 * Check if a given object implements the LootshopTransactionHistoryItem interface.
 */
export function instanceOfLootshopTransactionHistoryItem(value: object): value is LootshopTransactionHistoryItem {
    return true;
}

export function LootshopTransactionHistoryItemFromJSON(json: any): LootshopTransactionHistoryItem {
    return LootshopTransactionHistoryItemFromJSONTyped(json, false);
}

export function LootshopTransactionHistoryItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): LootshopTransactionHistoryItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'amountFormatted': json['amountFormatted'] == null ? undefined : json['amountFormatted'],
        'description': json['description'] == null ? undefined : json['description'],
        'itemCount': json['itemCount'] == null ? undefined : json['itemCount'],
        'paymentMethod': json['paymentMethod'] == null ? undefined : json['paymentMethod'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'isGiftCard': json['isGiftCard'] == null ? undefined : json['isGiftCard'],
    };
}

export function LootshopTransactionHistoryItemToJSON(json: any): LootshopTransactionHistoryItem {
    return LootshopTransactionHistoryItemToJSONTyped(json, false);
}

export function LootshopTransactionHistoryItemToJSONTyped(value?: LootshopTransactionHistoryItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'amount': value['amount'],
        'amountFormatted': value['amountFormatted'],
        'description': value['description'],
        'itemCount': value['itemCount'],
        'paymentMethod': value['paymentMethod'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'isGiftCard': value['isGiftCard'],
    };
}

